import { createPopper } from '@popperjs/core';

// import "@popperjs/core/dist/umd/popper"
import "bootstrap/js/dist/util.js";
import "bootstrap/js/dist/dropdown.js";
import "bootstrap/js/dist/collapse.js";
import "bootstrap/js/dist/modal.js";

// import "popper.js/dist/popper-utils.min.js";
// import "popper.js/dist/popper.min.js";
import "date.format.js";


(function($) {
	"use strict";

	$(window).load(function() {
		var $sidebar = $("#chat-sidebar");
		var fixed = false;
		var footerReached = false;

		var signupHeight, navHeight, windowTop, windowBottom, footerTop;

		function calcValues() {
			signupHeight = $(".signup-section").outerHeight();
			navHeight = $(".site-header").outerHeight();

			windowTop = $(window).scrollTop() - signupHeight;
			windowBottom = $(window).scrollTop() + $(window).height();

			footerTop = $(".site-footer").offset().top;
		}

		function offsetSidebar() {
			// if the top of the content section has reached the bottom of the navbar
			if (windowTop >= 0) {
				$sidebar.addClass("fixed").css({
					top: navHeight
				});
				fixed = true;
				if ((footerReached = true)) {
					$sidebar.removeClass("footer-reached");
					footerReached = false;loc
				}
			} else {
				$sidebar.removeClass("fixed");
				fixed = false;
			}

			if (fixed === true && windowBottom >= footerTop) {
				fixed = false;
				footerReached = true;
				$sidebar.removeClass("fixed").addClass("footer-reached");
			}
		}

		$(window).scroll(function() {
			if ($(window).width() >= 992) {
				calcValues();
				offsetSidebar();
			}
		});
		$(document).ready(function() {
			calcValues();
			offsetSidebar();
		});

		calcValues();
		offsetSidebar();
	});

	$.streamApp = {
		init: function() {
			//Initialize layout specific players
			this.local_init();
		},

		local_init: function() {
			// console.log("Must define layout specific init function.");
		},

		local_bind: function() {
			//Call layout specific functions
		}
	};

	$(document).ready(function($) {
		// Make nav links scroll down the page if they're anchor links
		$(".scrollto li a[href^='#']").on("click", function(e) {
			e.preventDefault();

			var hash = this.hash;
			$("html, body").animate({
					scrollTop: $(hash).offset().top
				},
				750,
				function() {
					window.location.hash = hash;
				}
			);
		});

		$("#sidebar-toggle").on("click", function() {
			$(".livestream-page-container")
				.toggleClass("sidebar-visible")
				.toggleClass("sidebar-hidden");
		});
	});

	$(window).load(function() {

		if ($('.stream-item').length) {
			var now = new Date(),
				today = now.format('Y-m-d'),
				currentTime = now.format('Hi'),
				yesterday = new Date(today);

			yesterday.setDate(yesterday.getDate() - 1);


			$('.stream-item').each(function(idx, el) {
				el = $(el)
				// Get time from attribute
				var startDateTime = new Date(el.data('start'));

				if (el.data('end')) {
					var endDateTime = new Date(el.data('end'));
				}

				// Update displayed time
				el.find('.day').text(startDateTime.format('j'));
				el.find('.month').text(startDateTime.format('M'));
				el.find('.time span').text(startDateTime.format('H:i'));

				var isLive = false;
				if (now >= startDateTime && now <= endDateTime) {
					isLive = true;
				}

				if (endDateTime) {
					// if stream started yesterday and its NOT live, hide it
					if (startDateTime.format('Y-m-d') === yesterday.format('Y-m-d')) {
						if (!isLive) {
							el.hide();
						}
					}

					// if is currently live...
					if (isLive) {
						el.find('.live-indicator').addClass('visible');
						el.find('.lockedin-tile').addClass('live');
					}
					if (startDateTime.format('Y-m-d') == today) {
						// else check if its live
						el.find('.today-indicator').addClass('visible');
					}
				}
				// theres no end date given
				else {
					// If its today
					if (startDateTime.format('Y-m-d') === today) {
						var startTime = startDateTime.format('Hi');
						let timeDiff = currentTime - startTime;

						//Assume 60 minute stream
						if (timeDiff >= 0 && timeDiff <= 60) {
							el.find('.live-indicator').addClass('visible');
							el.find('.lockedin-tile').addClass('live');
						} else {
							// Otherwise its just today
							el.find('.today-indicator').addClass('visible');
						}
					}
				}
			})
		}
	})

})(jQuery);